import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useSiteSettings } from "@/context/SiteSettingsContext";

function setMetaTag(attr, attrValue, content) {
  let el = document.querySelector(`meta[${attr}="${attrValue}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, attrValue);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function resolveTitle(path, firmName, title) {
  if (title) return String(title);
  if (path === "/") return `${firmName} - Cumplimos por ti`;
  if (path === "/admin") return `Panel Admin — ${firmName}`;
  if (path === "/portal") return `Portal Clientes — ${firmName}`;
  if (path.startsWith("/servicios")) return `Servicios — ${firmName}`;
  return `${firmName} - Cumplimos por ti`;
}

export default function SEOHead({ title, description }) {
  const settings = useSiteSettings();
  const { pathname } = useLocation();
  const firmName = settings?.firm_name || "Petrocontrol";

  useEffect(() => {
    const pageTitle = resolveTitle(pathname, firmName, title);
    const pageDesc = String(
      description ||
      `${firmName} - Gestión de permisos CNE, controles volumétricos SAT y servicios regulatorios para empresas del sector energético en México.`
    );

    document.title = pageTitle;
    setMetaTag("name", "description", pageDesc);
    setMetaTag("property", "og:title", pageTitle);
    setMetaTag("property", "og:description", pageDesc);
    setMetaTag("property", "og:type", "website");
  }, [title, description, firmName, pathname]);

  return null;
}
